<div class="flex-grow w-full">
    <h2 class="text-lg flex items-center gap-2 leading-[1] justify-between md:justify-start lg:justify-between xl:justify-start">
        <button (click)="changeWeek(-1)" [disabled]="!canGoBack" [class.opacity-50]="!canGoBack" [class.cursor-not-allowed]="!canGoBack">
            <img src="/assets/images/icons/arrow.svg" alt="previous-week" />
        </button>
        <span>
            <span class="me-1">{{'orderflow.recipeselection.menu_for' |translate}}</span>
            <span class="text-e-orange">{{selectedWeek?.from| localizedDate: 'dd MMM'}} - {{selectedWeek?.to | localizedDate: 'dd MMM'}}</span>
        </span>
        <button (click)="changeWeek(1)" [disabled]="!canGoForward" [class.opacity-50]="!canGoForward" [class.cursor-not-allowed]="!canGoForward">
            <img src="/assets/images/icons/arrow.svg" alt="next-week" class="rotate-180" />
        </button>
    </h2>
</div>